<template>
  <div class="realname-dialog">
    <div class="form-container">
      <div class="inner-nav">
        <span class="back-link" @click="goBack">
          <i class="el-icon-arrow-left"></i>
          返回
        </span>
        <span class="crumb-sep">/</span>
        <span class="crumb-current">实名认证</span>
      </div>
      <div class="title">实名认证</div>
      <div class="section-card">
        <div class="section-title">个人资料</div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>考试类型</div>
          <div class="right">
            <el-radio-group v-model="examType" :disabled="isReadOnlyMode">
              <el-radio :label="0">初次培训</el-radio>
              <el-radio :label="1">换证培训</el-radio>
              <el-radio :label="2">师资培训</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>真实姓名</div>
          <div class="right">
            <el-input
              v-model="realname"
              placeholder="请输入您的真实姓名"
              :disabled="isReadOnlyMode"
            ></el-input>
          </div>
        </div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>身份证号</div>
          <div class="right">
            <el-input
              v-model="idno"
              placeholder="请输入您的身份证号"
              maxlength="18"
              :disabled="isReadOnlyMode"
            ></el-input>
          </div>
        </div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>所属专业</div>
          <div class="right">
            <el-select
              v-model="majorId"
              filterable
              placeholder="请选择您的所属专业"
              :loading="loadingMajorList"
              :disabled="isReadOnlyMode"
            >
              <el-option
                v-for="major in majorList"
                :key="major.majorId"
                :label="major.name"
                :value="major.majorId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="left"><span class="red">*</span>个人2寸照片</div>
          <div class="right img-mode">
            <el-upload
              class="pic-uploader"
              action="/file/importPicture"
              :http-request="uploadPic"
              :data="{ mode: 3 }"
              accept="image/*"
              name="pictureFile"
              :show-file-list="false"
              :on-error="handlePicUploadError"
              :v-loading="uploadingPersonalPicUrl"
              :disabled="isReadOnlyMode"
            >
              <img
                v-if="personalPicUrl.length > 0"
                :src="personalPicUrl"
                class="preview-pic"
              />
              <img
                v-else
                class="pic-uploader-bg"
                src="../../assets/realname/personal_pic_bg.png"
              />
            </el-upload>
            <div v-if="uploadingPersonalPicUrl" class="upload-hint">
              个人2寸照片上传中...
            </div>
          </div>
        </div>
        <div class="row">
          <div class="left"><span class="red">*</span>身份证人像面</div>
          <div class="right img-mode">
            <el-upload
              class="pic-uploader"
              action="/file/importPicture"
              :http-request="uploadPic"
              :data="{ mode: 0 }"
              accept="image/*"
              name="pictureFile"
              :show-file-list="false"
              :on-error="handlePicUploadError"
              :v-loading="uploadingIdImgUrl"
              :disabled="isReadOnlyMode"
            >
              <img
                v-if="idImgUrl.length > 0"
                :src="idImgUrl"
                class="preview-pic"
              />
              <img
                v-else
                class="pic-uploader-bg"
                src="../../assets/realname/id_img_bg.png"
              />
            </el-upload>
            <div v-if="uploadingIdImgUrl" class="upload-hint">
              身份证人像面上传中...
            </div>
          </div>
        </div>
        <div v-if="examType === 0" class="row">
          <div class="left"><span class="red">*</span>护士执业证书</div>
          <div class="right img-mode">
            <el-upload
              class="pic-uploader"
              action="/file/importPicture"
              :http-request="uploadPic"
              :data="{ mode: 1 }"
              accept="image/*"
              name="pictureFile"
              :show-file-list="false"
              :on-error="handlePicUploadError"
              :v-loading="uploadingNurseCertUrl"
              :disabled="isReadOnlyMode"
            >
              <img
                v-if="nurseCertUrl.length > 0"
                :src="nurseCertUrl"
                class="preview-pic"
              />
              <img
                v-else
                class="pic-uploader-bg"
                src="../../assets/realname/nurse_cert_bg.png"
              />
            </el-upload>
            <div v-if="uploadingNurseCertUrl" class="upload-hint">
              护士执业证书上传中...
            </div>
          </div>
        </div>
        <div v-if="examType === 1" class="row">
          <div class="left"><span class="red">*</span>往期结业证书</div>
          <div class="right img-mode">
            <el-upload
              class="pic-uploader"
              action="/file/importPicture"
              :http-request="uploadPic"
              :data="{ mode: 2 }"
              accept="image/*"
              name="pictureFile"
              :show-file-list="false"
              :on-error="handlePicUploadError"
              :v-loading="uploadingPreCertImgUrl"
              :disabled="isReadOnlyMode"
            >
              <img
                v-if="preCertImgUrl.length > 0"
                :src="preCertImgUrl"
                class="preview-pic"
              />
              <img
                v-else
                class="pic-uploader-bg"
                src="../../assets/realname/pre_cert_bg.png"
              />
            </el-upload>
            <div v-if="uploadingPreCertImgUrl" class="upload-hint">
              往期结业证书上传中...
            </div>
          </div>
        </div>
        <div v-if="examType === 1" class="row">
          <div class="left input-row"><span class="red">*</span>证书编号</div>
          <div class="right">
            <el-input
              v-model="preCertNo"
              placeholder="请输入8位证书编号"
              :disabled="isReadOnlyMode"
            ></el-input>
          </div>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">毕业院校</div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>学历</div>
          <div class="right">
            <el-select
              v-model="eduLevel"
              placeholder="请选择学历"
              :disabled="isReadOnlyMode"
            >
              <el-option
                v-for="edu in eduList"
                :key="edu.level"
                :label="edu.name"
                :value="edu.level"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-if="examType === 0" class="row">
          <div class="left"><span class="red">*</span>毕业证</div>
          <div class="right img-mode">
            <el-upload
              class="pic-uploader"
              action="/file/importPicture"
              :http-request="uploadPic"
              :data="{ mode: 4 }"
              accept="image/*"
              name="pictureFile"
              :show-file-list="false"
              :on-error="handlePicUploadError"
              :v-loading="uploadingEduPicUrl"
              :disabled="isReadOnlyMode"
            >
              <img
                v-if="eduPicUrl.length > 0"
                :src="eduPicUrl"
                class="preview-pic"
              />
              <img
                v-else
                class="pic-uploader-bg"
                src="../../assets/realname/education_img_bg.png"
              />
            </el-upload>
            <div v-if="uploadingEduPicUrl" class="upload-hint">
              毕业证上传中...
            </div>
          </div>
        </div>
      </div>

      <div class="section-card work-info">
        <div class="section-title">工作经历</div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>医院名称</div>
          <div class="right">
            <el-select
              v-model="hospital"
              filterable
              remote
              reserve-keyword
              placeholder="请输入您所在医院名称"
              :remote-method="loadHospital"
              :loading="loadingHospital"
              :disabled="isReadOnlyMode"
            >
              <el-option
                v-for="hos in hospitalList"
                :key="hos.hospital"
                :label="hos.hospital"
                :value="hos.hospital"
              >
              </el-option>
            </el-select>
            <div
              class="hospital-tips"
              :class="{ disabled: isReadOnlyMode }"
              @click="!isReadOnlyMode && showHospitalTips()"
            >
              找不到您所在医院？
            </div>
          </div>
        </div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>医院等级</div>
          <div class="right">
            <el-input
              v-model="hosLevel"
              placeholder="请输入您所在医院的等级"
              :disabled="isReadOnlyMode"
            ></el-input>
          </div>
        </div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>办公室电话</div>
          <div class="right">
            <el-input
              v-model="officeTel"
              placeholder="请输入您所在办公室电话"
              :disabled="isReadOnlyMode"
            ></el-input>
          </div>
        </div>
        <div class="row">
          <div class="left input-row"><span class="red">*</span>职称</div>
          <div class="right">
            <el-input
              v-model="techTitle"
              placeholder="请输入您的职称"
              :disabled="isReadOnlyMode"
            ></el-input>
          </div>
        </div>
        <div v-if="examType === 0" class="row">
          <div class="left">
            <span class="red">*</span>医疗机构<br/>执业许可证副本
          </div>
          <div class="right img-mode">
            <el-upload
              class="pic-uploader"
              action="/file/importPicture"
              :http-request="uploadPic"
              :data="{ mode: 5 }"
              accept="image/*"
              name="pictureFile"
              :show-file-list="false"
              :on-error="handlePicUploadError"
              :v-loading="uploadingHosCertImgUrl"
              :disabled="isReadOnlyMode"
            >
              <img
                v-if="hosCertImgUrl.length > 0"
                :src="hosCertImgUrl"
                class="preview-pic"
              />
              <img
                v-else
                class="pic-uploader-bg"
                src="../../assets/realname/hos_cert_img_bg.png"
              />
            </el-upload>
            <div v-if="uploadingHosCertImgUrl" class="upload-hint">
              医疗机构执业许可证副本上传中...
            </div>
          </div>
        </div>
        <div class="row">
          <div class="left"><span class="red">*</span>山东省护士<br/>岗位培训申请表</div>
          <div class="right img-mode">
            <el-upload
              class="pic-uploader"
              action="/file/importPicture"
              :http-request="uploadPic"
              :data="{ mode: 6 }"
              accept="image/*"
              name="pictureFile"
              :show-file-list="false"
              :on-error="handlePicUploadError"
              :v-loading="uploadingApplyUrl"
              :disabled="isReadOnlyMode"
            >
              <img
                v-if="applyUrl.length > 0"
                :src="applyUrl"
                class="preview-pic"
              />
              <img
                v-else
                class="pic-uploader-bg"
                src="../../assets/realname/apply_bg.png"
              />
            </el-upload>
            <div v-if="uploadingApplyUrl" class="upload-hint">
              山东省护士岗位培训申请表上传中...
            </div>
          </div>
        </div>
      </div>

      <div class="submit-wrap">
        <el-button
          type="primary"
          class="submit-btn"
          :loading="submitting"
          :disabled="isSubmitDisabled"
          @click="handleSubmit"
        >
          {{ submitButtonText }}
        </el-button>
        <div
          v-if="submitHintText"
          class="submit-hint"
          :class="{ disabled: isSubmitDisabled }"
        >
          {{ submitHintText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      submitting: false,
      realname: "",
      idno: "",
      personalPicUrl: "", // 个人2寸照片
      uploadingPersonalPicUrl: false, // 个人2寸照片
      idImgUrl: "", // 身份证照片
      uploadingIdImgUrl: false, // 身份证照片
      nurseCertUrl: "", // 护士执业证书
      uploadingNurseCertUrl: false, // 护士执业证书
      preCertImgUrl: "", // 往期结业证书
      uploadingPreCertImgUrl: false, // 往期结业证书
      preCertNo: "", // 往期结业证书编号
      majorId: null, // 所属专业 id
      majorType: null, // 所属专业类型，随所选专业带出
      majorList: [], // 专业列表
      loadingMajorList: false, // 加载专业列表标记
      eduLevel: "", // 学历 0:中专 1：大专 2：本科 3：研究生 4：博士 5：其他
      eduList: [
        { level: 0, name: "中专" },
        { level: 1, name: "大专" },
        { level: 2, name: "本科" },
        { level: 3, name: "研究生" },
        { level: 4, name: "博士" },
        { level: 5, name: "其它" }
      ],
      eduPicUrl: "", // 毕业证照片
      uploadingEduPicUrl: false, // 毕业证照片
      hospital: "", // 选中的医院
      hospitalList: [], // 医院列表
      loadingHospital: false, // 加载医院列表的标志
      hosLevel: "", // 医院等级
      officeTel: "", // 办公室电话
      techTitle: "", // 职称
      hosCertImgUrl: "", // 医院执业资格证
      uploadingHosCertImgUrl: false, // 医院执业资格证
      applyUrl: "", // 山东省护士岗位培训申请表
      uploadingApplyUrl: false, // 山东省护士岗位培训申请表
      examType: 0, // 0：初次培训 1：换证培训 2：师资培训
      confirmLock: false, // 防止重复弹出确认框
      lastSubmitTs: 0, // 防暴力点击时间戳
      submitMinInterval: 1800, // 防暴力点击最小间隔（毫秒）
      submitProgressText: "", // 提交进度文案
      isReadOnlyMode: false, // 审核中/已通过时，页面只读
      readOnlyModeText: "" // 只读模式提示文案
    };
  },
  computed: {
    isSubmitDisabled() {
      return (
        this.submitting ||
        this.confirmLock ||
        this.hasUploadingTask ||
        this.isReadOnlyMode
      );
    },
    hasUploadingTask() {
      return (
        this.uploadingPersonalPicUrl ||
        this.uploadingIdImgUrl ||
        this.uploadingNurseCertUrl ||
        this.uploadingPreCertImgUrl ||
        this.uploadingEduPicUrl ||
        this.uploadingHosCertImgUrl ||
        this.uploadingApplyUrl
      );
    },
    uploadingTaskLabels() {
      const labels = [];
      if (this.uploadingPersonalPicUrl) labels.push("个人2寸照片");
      if (this.uploadingIdImgUrl) labels.push("身份证人像面");
      if (this.uploadingNurseCertUrl) labels.push("护士执业证书");
      if (this.uploadingPreCertImgUrl) labels.push("往期结业证书");
      if (this.uploadingEduPicUrl) labels.push("毕业证");
      if (this.uploadingHosCertImgUrl) labels.push("医疗机构执业许可证副本");
      if (this.uploadingApplyUrl) labels.push("山东省护士岗位培训申请表");
      return labels;
    },
    submitButtonText() {
      if (this.submitProgressText) {
        return this.submitProgressText;
      }
      if (this.isReadOnlyMode) {
        return this.readOnlyModeText || "当前不可提交";
      }
      if (this.confirmLock) {
        return "请确认";
      }
      return "提交申请";
    },
    submitHintText() {
      if (this.submitting) {
        return "实名认证提交中，请稍候...";
      }
      if (this.confirmLock) {
        return "请先完成提交确认";
      }
      if (this.isReadOnlyMode) {
        return this.readOnlyModeText || "当前不可提交";
      }
      if (this.hasUploadingTask) {
        return `${this.uploadingTaskLabels.join("、")}上传中，请等待完成后再提交`;
      }
      return this.getFirstValidationError() || "";
    }
  },
  created() {
    const user = JSON.parse(localStorage.getItem("pc_user"));
    if (user !== null && user !== undefined) {
      this.fillFormFromUser(user);
      this.initReadOnlyState(user);
      this.loadMajorList();
      this.refreshLatestUserInfo();
    } else {
      this.$router.push({ path: "/" });
    }
  },
  methods: {
    async refreshLatestUserInfo() {
      try {
        const res = await httpRequest("/app/user", "get", null);
        if (res && res.code === 200 && res.data) {
          localStorage.setItem("pc_user", JSON.stringify(res.data));
          this.fillFormFromUser(res.data);
          this.initReadOnlyState(res.data);
        }
      } catch (error) {
        console.warn("刷新实名认证用户信息失败:", error);
      }
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push({ path: "/mine" });
    },
    initReadOnlyState(user) {
      if (!user) {
        this.isReadOnlyMode = false;
        this.readOnlyModeText = "";
        return;
      }
      const authStatus = Number(user.authStatus);
      const inAudit = authStatus === 1;
      const approved = authStatus === 2;
      this.isReadOnlyMode = inAudit || approved;
      if (approved) {
        this.readOnlyModeText = "已通过实名认证";
      } else if (inAudit) {
        this.readOnlyModeText = "实名认证审核中";
      } else {
        this.readOnlyModeText = "";
      }
    },
    fillFormFromUser(user) {
      const normalize = value =>
        value === null || value === undefined ? "" : String(value);
      this.realname = normalize(user.realName);
      this.idno = normalize(user.identity);
      this.personalPicUrl = normalize(user.pictureUrl);
      this.idImgUrl = normalize(user.identityUrl);
      this.nurseCertUrl = normalize(user.vocatCertiUrl);
      this.preCertImgUrl = normalize(user.completeCourseUrl);
      this.preCertNo = normalize(user.certificateNumber);
      this.majorId =
        user.majorId === null || user.majorId === undefined
          ? null
          : Number(user.majorId);
      this.majorType =
        user.majorType === null || user.majorType === undefined
          ? null
          : Number(user.majorType);
      this.examType =
        this.preCertNo.length > 0 || this.preCertImgUrl.length > 0 ? 1 : 0;

      const eb = user.eb || {};
      const we = user.we || {};
      if (eb.edtBg !== null && eb.edtBg !== undefined && eb.edtBg !== "") {
        this.eduLevel = Number(eb.edtBg);
      }
      this.eduPicUrl = normalize(eb.graduationUrl);

      this.hospital = normalize(we.hospital);
      this.hosLevel = normalize(we.hospitalLevel);
      this.officeTel = normalize(we.officePhone);
      this.techTitle = normalize(we.position);
      this.hosCertImgUrl = normalize(we.licenseUrl);
      this.applyUrl = normalize(we.applicationUrl);
    },
    normalizeMajorList(list) {
      if (!Array.isArray(list)) {
        return [];
      }
      return list
        .map(item => {
          const majorId = Number(item && item.majorId);
          const majorType = Number(
            item && item.type !== undefined
              ? item.type
              : item && item.majorType !== undefined
              ? item.majorType
              : this.majorType
          );
          return {
            majorId: Number.isFinite(majorId) ? majorId : null,
            majorType: Number.isFinite(majorType) ? majorType : null,
            name: (item && item.name) || ""
          };
        })
        .filter(item => item.majorId !== null && item.name.length > 0);
    },
    async loadMajorList() {
      this.loadingMajorList = true;
      try {
        let res = await httpRequest("/app/major/majors", "get", null);
        if (
          !res ||
          res.code !== 200 ||
          !Array.isArray(res.data) ||
          res.data.length === 0
        ) {
          const fallbackMajorType = Number(this.majorType);
          if (Number.isFinite(fallbackMajorType)) {
            // 兼容旧接口或旧缓存场景，必要时再按已有 majorType 回退
            res = await httpRequest("/app/major/majors", "get", {
              type: fallbackMajorType
            });
          }
        }
        if (res && res.code === 200) {
          this.majorList = this.normalizeMajorList(res.data);
          const exists = this.majorList.some(
            major => Number(major.majorId) === Number(this.majorId)
          );
          if (!exists) {
            this.majorId =
              this.majorList.length > 0 ? this.majorList[0].majorId : null;
          }
          return;
        }
        this.majorList = [];
        this.majorId = null;
        this.$message.error((res && res.message) || "加载专业列表失败");
      } catch (error) {
        this.majorList = [];
        this.majorId = null;
        this.$message.error("加载专业列表失败");
      } finally {
        this.loadingMajorList = false;
      }
    },
    showHospitalTips() {
      this.$alert(
        "如列表中无您的医院名称或医院名称有错误，请联系工作人员增改，联系电话：0531-88951587",
        "提示",
        {
          confirmButtonText: "确定"
        }
      );
    },
    async loadHospital(hosKeyword) {
      if (hosKeyword !== "") {
        this.loadingHospital = true;
        try {
          const params = { queryParam: hosKeyword };
          const res = await httpRequest(
            "/app/hospital/hospitals",
            "get",
            params
          );
          if (res !== null && res !== undefined && res.code === 200) {
            this.hospitalList = res.data;
          } else {
            this.hospitalList = [];
          }
        } catch (error) {
          this.hospitalList = [];
        }
        this.loadingHospital = false;
      } else {
        this.hospitalList = [];
      }
    },
    getPersonalValidationError() {
      if (this.realname.length === 0) {
        return "请输入您的真实姓名！";
      }
      if (this.idno.length !== 18) {
        return "请输入18位的身份证号！";
      }
      if (this.majorId === null || this.majorId === undefined) {
        return "请选择所属专业！";
      }
      if (this.personalPicUrl.length === 0) {
        return "请上传您的个人2寸照片！";
      }
      if (this.idImgUrl.length === 0) {
        return "请上传您的身份证照片！";
      }
      if (this.examType === 0 && this.nurseCertUrl.length === 0) {
        return "请上传您的护士执业证书照片！";
      }
      if (this.examType === 1 && this.preCertImgUrl.length === 0) {
        return "请上传您的往期结业证书照片！";
      }
      if (this.examType === 1 && this.preCertNo.length === 0) {
        return "请输入您的证书编号！";
      }
      if (this.examType === 1 && this.preCertNo.trim().length !== 8) {
        return "证书编号格式不正确，请输入8位证书编号！";
      }
      return "";
    },
    validatePersonalInfo() {
      const error = this.getPersonalValidationError();
      if (error) {
        this.$message.error(error);
        return false;
      }
      return true;
    },
    getEduValidationError() {
      if (this.eduLevel === "" || this.eduLevel === null) {
        return "请选择您的学历！";
      }
      if (this.examType === 0 && this.eduPicUrl.length === 0) {
        return "请上传您的毕业证书！";
      }
      return "";
    },
    validateEduInfo() {
      const error = this.getEduValidationError();
      if (error) {
        this.$message.error(error);
        return false;
      }
      return true;
    },
    getWorkValidationError() {
      if (this.hospital.length === 0) {
        return "请输入您所在医院！";
      }
      if (this.hosLevel.length === 0) {
        return "请输入您所在医院等级！";
      }
      if (this.officeTel.length === 0) {
        return "请输入您所在办公室电话！";
      }
      if (this.techTitle.length === 0) {
        return "请输入您的职称！";
      }
      if (this.examType === 0 && this.hosCertImgUrl.length === 0) {
        return "请上传您所在医院执业许可证副本照片！";
      }
      if (this.applyUrl.length === 0) {
        return "请上传山东省护士岗位培训申请表！";
      }
      return "";
    },
    validateWorkInfo() {
      const error = this.getWorkValidationError();
      if (error) {
        this.$message.error(error);
        return false;
      }
      return true;
    },
    getFirstValidationError() {
      return (
        this.getPersonalValidationError() ||
        this.getEduValidationError() ||
        this.getWorkValidationError()
      );
    },
    buildPersonalParams() {
      const selectedMajor = this.majorList.find(
        major => Number(major.majorId) === Number(this.majorId)
      );
      return {
        majorType: selectedMajor
          ? Number(selectedMajor.majorType)
          : Number.isFinite(Number(this.majorType))
          ? Number(this.majorType)
          : 0,
        majorId: Number(this.majorId),
        realName: this.realname,
        identity: this.idno,
        pictureUrl: this.personalPicUrl,
        identityUrl: this.idImgUrl,
        vocatCertiUrl: this.examType === 0 ? this.nurseCertUrl : "",
        completeCourseUrl: this.examType === 1 ? this.preCertImgUrl : "",
        certificateNumber: this.examType === 1 ? this.preCertNo.trim() : ""
      };
    },
    buildEduParams() {
      return {
        edtBg: this.eduLevel,
        graduationUrl: this.examType === 0 ? this.eduPicUrl : ""
      };
    },
    buildWorkParams() {
      return {
        hospital: this.hospital,
        position: this.techTitle,
        hospitalLevel: this.hosLevel,
        officePhone: this.officeTel,
        licenseUrl: this.examType === 0 ? this.hosCertImgUrl : "",
        applicationUrl: this.applyUrl
      };
    },
    buildSubmitParams() {
      return {
        userInfo: this.buildPersonalParams(),
        eb: this.buildEduParams(),
        we: this.buildWorkParams()
      };
    },
    persistUser(res) {
      if (res && res.code === 200 && res.data) {
        localStorage.setItem("pc_user", JSON.stringify(res.data));
      }
    },
    async handleSubmit() {
      if (this.submitting || this.confirmLock) {
        return;
      }
      if (this.isReadOnlyMode) {
        this.$message.warning(this.readOnlyModeText || "当前不可修改");
        return;
      }
      if (this.hasUploadingTask) {
        this.$message.warning("图片上传中，请稍后再提交");
        return;
      }
      const now = Date.now();
      if (now - this.lastSubmitTs < this.submitMinInterval) {
        this.$message.warning("请勿频繁点击提交");
        return;
      }
      if (
        !this.validatePersonalInfo() ||
        !this.validateEduInfo() ||
        !this.validateWorkInfo()
      ) {
        return;
      }

      try {
        this.confirmLock = true;
        await this.$confirm("确认提交实名认证申请吗？", "提示", {
          confirmButtonText: "确认提交",
          cancelButtonText: "取消",
          type: "warning"
        });
      } catch (error) {
        return;
      } finally {
        this.confirmLock = false;
      }

      this.submitting = true;
      this.lastSubmitTs = Date.now();
      this.submitProgressText = "提交中";
      const submitStart = Date.now();
      try {
        const submitRes = await httpRequest(
          "/app/user/real-name-submit",
          "post",
          this.buildSubmitParams()
        );
        if (!submitRes || submitRes.code !== 200) {
          this.$message.error(
            (submitRes && submitRes.message) || "实名认证提交失败，请重试"
          );
          return;
        }
        this.persistUser(submitRes);
        this.initReadOnlyState(submitRes.data);
        const totalCost = Date.now() - submitStart;
        console.info(
          `[RealName] submit cost: total=${totalCost}ms`
        );
        this.$message.success("您的申请已提交，等待审核！");
        this.$router.push({ path: "/mine" });
      } catch (error) {
        this.$message.error("提交失败，请重试");
      } finally {
        this.submitting = false;
        this.submitProgressText = "";
      }
    },
    handlePicUploadError() {
      this.$message.error("上传失败，请重试");
    },
    setUploadState(mode, uploading, value) {
      if (mode === 0) {
        this.uploadingIdImgUrl = uploading;
        if (value !== undefined) this.idImgUrl = value;
      } else if (mode === 1) {
        this.uploadingNurseCertUrl = uploading;
        if (value !== undefined) this.nurseCertUrl = value;
      } else if (mode === 2) {
        this.uploadingPreCertImgUrl = uploading;
        if (value !== undefined) this.preCertImgUrl = value;
      } else if (mode === 3) {
        this.uploadingPersonalPicUrl = uploading;
        if (value !== undefined) this.personalPicUrl = value;
      } else if (mode === 4) {
        this.uploadingEduPicUrl = uploading;
        if (value !== undefined) this.eduPicUrl = value;
      } else if (mode === 5) {
        this.uploadingHosCertImgUrl = uploading;
        if (value !== undefined) this.hosCertImgUrl = value;
      } else if (mode === 6) {
        this.uploadingApplyUrl = uploading;
        if (value !== undefined) this.applyUrl = value;
      }
    },
    async uploadPic(params) {
      if (this.isReadOnlyMode) {
        this.$message.warning(this.readOnlyModeText || "当前不可修改");
        return;
      }
      const mode = params.data.mode;
      if (mode < 0 || mode > 6) {
        return;
      }
      this.setUploadState(mode, true, URL.createObjectURL(params.file));

      const formData = new FormData();
      formData.append(params.filename, params.file);
      try {
        const res = await httpRequest(params.action, "post", formData);
        if (res !== null && res !== undefined && res.code === 200) {
          this.$message.success("上传成功");
          this.setUploadState(mode, false, res.data[0]);
          return;
        }
        this.setUploadState(mode, false, "");
        this.$message.error((res && res.message) || "上传失败，请重试");
      } catch (error) {
        this.setUploadState(mode, false, "");
        this.$message.error("上传失败，请重试");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.realname-dialog {
  width: 100%;
  min-height: 1000px;
  background: transparent;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 42px;
  color: #333333;

  .form-container {
    width: 960px;
    margin: 20px auto 0 auto;
  }

  .inner-nav {
    display: flex;
    align-items: center;
    height: 44px;
    margin-bottom: 10px;
    color: #64748b;
    font-size: 14px;

    .back-link {
      cursor: pointer;
      color: #2b6cb0;
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }

    .crumb-sep {
      margin: 0 8px;
      color: #94a3b8;
    }

    .crumb-current {
      color: #334155;
    }
  }

  .title {
    height: 64px;
    line-height: 64px;
    padding-left: 32px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    background: #3f93dc;
    border-radius: 12px 12px 0 0;
  }

  .section-card {
    background: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(148, 163, 184, 0.08);
    padding: 24px 32px 32px 32px;
    margin-bottom: 24px;
    transition: box-shadow 0.3s ease;

    &:first-of-type {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-top: none;
    }

    &:hover {
      box-shadow: 0 6px 24px rgba(148, 163, 184, 0.12);
    }

    .section-title {
      font-size: 18px;
      color: #1e293b;
      font-weight: 600;
      text-align: left;
      margin-bottom: 24px;
      padding-left: 12px;
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 18px;
        background: #035db3;
        border-radius: 2px;
      }
    }
  }

  .work-info {
    .hospital-tips {
      color: #f59e0b;
      font-size: 13px;
      line-height: 20px;
      margin-top: 8px;
      cursor: pointer;
      display: inline-block;
      transition: color 0.3s;
      
      &:hover {
        color: #d97706;
      }

      &.disabled {
        color: #cbd5e1;
        cursor: not-allowed;
      }
    }
  }

  .row {
    margin-top: 20px;
    display: flex;
    align-items: flex-start;

    .left {
      width: 160px;
      text-align: right;
      font-size: 14px;
      line-height: 40px;
      color: #475569;
      flex-shrink: 0;
      font-weight: 500;

      .red {
        color: #ef4444;
        margin-right: 4px;
        font-family: Arial, sans-serif;
      }
    }

    .right {
      flex: 1;
      margin-left: 24px;
      min-height: 40px;
      text-align: left;

      .el-input,
      .el-select {
        width: 100%;
        max-width: 520px;
      }
      
      .el-radio-group {
        display: flex;
        align-items: center;
        height: 40px;
      }
      
      /* Use a slightly deeper shadow/focus state for inputs if needed */
      ::v-deep .el-input__inner {
        border-radius: 6px;
        border-color: #cbd5e1;
        transition: all 0.3s;
        
        &:focus {
          border-color: #035db3;
          box-shadow: 0 0 0 2px rgba(3, 93, 179, 0.1);
        }
      }

      .pic-uploader {
        cursor: pointer;
        display: block;

        .preview-pic,
        .pic-uploader-bg {
          width: 520px;
          height: 240px;
          object-fit: contain;
          border-radius: 8px;
          background: #f8fafc;
          transition: all 0.3s ease;
        }

        .pic-uploader-bg {
          border: 1px dashed #cbd5e1;
          
          &:hover {
            border-color: #035db3;
            background: #f1f5f9;
          }
        }

        .preview-pic {
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        }
      }
    }

    .img-mode {
      min-height: 240px;
    }

    .upload-hint {
      margin-top: 10px;
      font-size: 13px;
      line-height: 20px;
      color: #d46b08;
    }
  }

  .submit-wrap {
    margin-top: 40px;
    text-align: center;
  }

  .submit-btn {
    width: 380px;
    height: 48px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 24px;
    background: #035db3;
    border: none;
    box-shadow: 0 4px 12px rgba(3, 93, 179, 0.3);
    transition: all 0.3s ease;
    color: #ffffff;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(3, 93, 179, 0.4);
      background: #0f6abf;
    }
    
    &:active {
      transform: translateY(1px);
      box-shadow: 0 2px 8px rgba(3, 93, 179, 0.3);
    }
  }

  .submit-hint {
    margin-top: 12px;
    font-size: 14px;
    line-height: 22px;
    color: #d46b08;

    &.disabled {
      color: #909399;
    }
  }
}
</style>
